import script from "./PlayerStatsBreakdown.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerStatsBreakdown.vue?vue&type=script&setup=true&lang=js"

import "./PlayerStatsBreakdown.vue?vue&type=style&index=0&id=c507bef6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c507bef6"]])

export default __exports__